// CJS interop wrapper for feather-icons-react
// Vite's pre-bundling can double-wrap the CJS default export
import * as FeatherIconModule from 'feather-icons-react';

let FeatherIcon: any = FeatherIconModule;
while (FeatherIcon && typeof FeatherIcon !== 'function' && FeatherIcon.default) {
  FeatherIcon = FeatherIcon.default;
}

export default FeatherIcon;
